import React from 'react'
import { Tooltip } from 'sutra/components/Tooltip/Tooltip'

import { DateLabel } from 'features/ask-yogi/features/conversation/components/VerbatimCard/verbatim-card.styles'
import { ProductLink } from 'features/ask-yogi/features/conversation/components/VerbatimCardProductLink/verbatim-card-product-link.styles'
import { buildProjectCatalogPathFromLens } from 'features/catalog/utils'

export interface VerbatimCardProductLinkProps {
  projectId: string
  productName: string
  /** Render a leading "·" — set when the relative date sits before the link. */
  showSeparator: boolean
}

/** The reviewed product's name on a reviews & ratings card, linking to its
 * catalog page. */
const VerbatimCardProductLink: React.FC<VerbatimCardProductLinkProps> = ({
  projectId,
  productName,
  showSeparator,
}) => (
  <>
    {showSeparator && <DateLabel aria-hidden>·</DateLabel>}
    <Tooltip content="View product in catalog">
      <ProductLink
        to={buildProjectCatalogPathFromLens(
          projectId,
          'product_hierarchy',
          productName,
        )}
        target="_blank"
        rel="noopener noreferrer"
        // The card's own click handler selects it for copy — a link click
        // must only navigate.
        onClick={(event) => event.stopPropagation()}
      >
        {productName}
      </ProductLink>
    </Tooltip>
  </>
)

export default VerbatimCardProductLink
